<template>
    <div>
        <div
            v-if="!loading"
            class="caseTypeCard"
        >
            <img
                :src="getIconPath(casetype.id)"
                style="max-width:150px;max-height:48px;padding-right:20px;display:inline-block;"
            />
            <div
                style="display:inline-block;position:relative;"
            >
                <div
                    style="font-size: 24px;"
                >
                    {{ casetype.name }}
                </div>
                <div>Created {{ convertToCalRef(casetype.created_at) }}</div>
            </div>
            <div
                style="display:inline-block;float:right;vertical-align: middle;margin:5px;"
            >
                <v-btn
                    round
                    @click="showCaseNews = true"
                >
                    <v-icon
                        dark
                        left
                    >
                        mdi-newspaper
                    </v-icon>
                    News
                </v-btn>
                &nbsp;&nbsp;
                <v-btn
                    v-if="checkPermission('cases', PERMISSIONS.CAN_BULK)"
                    :to="{name: 'CaseImport', params: {id: $route.params.id}}"
                    round
                    color="yellow"
                >
                    <v-icon
                        dark
                        left
                    >
                        mdi-database-import
                    </v-icon>
                    Import
                </v-btn>
                &nbsp;&nbsp;
                <v-btn
                    v-if="checkPermission('cases', PERMISSIONS.CAN_CREATE)"
                    :to="{name: 'NewCase', params: {casetype: casetype.id}}"
                    dark
                    round
                    color="green"
                >
                    <v-icon dark left>add</v-icon>
                    New Case
                </v-btn>
            </div>
        </div>
        <div
            v-if="!loading"
            style="padding-top: 20px;"
        >
            <CaseList
                :caseType="casetype.id"
                ref="caselist"
            />
        </div>
        <v-layout
            v-else
            align-center
            justify-center
            column
            fill-height
            style="height: 60vh;"
        >
            <div>
                <v-icon
                    size="72"
                >
                    mdi-briefcase
                </v-icon>
            </div>
            <v-progress-circular
                indeterminate
                style="padding: 10px;"
            />
        </v-layout>
        <v-dialog
            v-model="showCaseNews"
            width="1200"
        >
            <v-card>
                <v-toolbar
                    dense
                    flat
                >
                    News
                    <v-spacer />
                    <v-btn
                        fab
                        small
                        color="red"
                        dark
                        class="elevation-0"
                        @click="showCaseNews = !showCaseNews"
                    >
                        x
                    </v-btn>
                </v-toolbar>
                <v-layout
                    row
                    wrap
                >
                    <v-flex
                        sm3
                        style="display: flex;flex-direction: column;"
                    >
                        <v-text-field
                            v-model="newsSearch"
                            box
                            hide-details
                            :loading="newsLoading"
                            label="Search Articles"
                            clearable
                            style="flex-grow: 0;"
                        />
                        <v-list
                            three-line
                            style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                        >
                            <v-list-tile
                                v-for="na in news"
                                :key="na.id"
                                :class="{ 'primary--text': focusArticle == na.id }"
                                @click="oepnArticle(na.id)"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="na.title"></v-list-tile-title>
                                    <v-list-tile-sub-title
                                        v-if="na.casetype"
                                        v-html="truncatedBody(na.casetype.name)"
                                        style="font-weight: bold;"
                                    />
                                    <v-list-tile-sub-title v-html="truncatedBody(na.body)"></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="!canPrev"
                                icon
                                @click="goPage(-1)"
                            >
                                <
                            </v-btn>
                            &nbsp;
                            {{page * 10 - 9}}
                            -
                            {{page * 10 > total ? total : page * 10}}
                             of 
                            {{total}}
                            &nbsp;
                            <v-btn
                                :disabled="!canNext"
                                icon
                                @click="goPage(1)"
                            >
                                >
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-flex>
                    <v-flex
                        sm9
                    >
                        <v-card
                            v-if="focusArticle"  
                            style="margin: 0 10px 0 10px;"
                        >
                            <NewsEditor
                                :article.sync="focusArticle"
                                :casetype="$route.params.id"
                                :readonly="!checkPermission('case_manage_news', PERMISSIONS.CAN_CREATE)"
                                @changed="changed = $event"
                                @cancel="focusArticle = null"
                                @fetch="getNewsarticles(newsSearch)"
                                @focus="focusArticle = $event;getNewsarticles(newsSearch)"
                            />
                        </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          v-if="checkPermission('case_manage_news', PERMISSIONS.CAN_CREATE)"
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select an article to manage, or</b><br />
                          <v-btn
                            @click="focusArticle = 'new'"
                          >
                            Create a New Article
                          </v-btn>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About News Articles
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              News Articles allow you to create posts that are accessible to all users, or only logged in users. Articles can also be used outside of CaseLocker with our API.<br /><br />
                              Articles may contain text, video links, and files.
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import api from '@/api'
  import CaseList from './CaseList.vue'
  import NewsEditor from '@/components/admin/NewsEditor'
  
  export default {
    name: 'CaseType',
    components: {
        CaseList,
        NewsEditor
    },
    data () {
      return {
        casetype: {},
        loading: true,
        showCaseNews: false,
        news: [],
        newsLoading: false,
        newsSearch: '',
        focusArticle: null,
        page: 1,
        canNext: false,
        canPrev: false,
        total: 0,
      }
    },
    watch: {
        showCaseNews () {
            if (this.showCaseNews) {
                this.getNewsarticles()
            } else {
                this.focusArticle = null
                this.news = []
                this.page = 1
                this.newsSearch = ''
            }
        },
        newsSearch () {
            this.page = 1
            this.getNewsarticles(this.newsSearch)
        },
    },
    created () {
        this.documentTitle('')
        if (this.$route.params.id) {
            this.fetch()
        } else {
            this.$router.push({ name: 'CaseTypeList' })
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.$refs.caselist.beforeEnter(to, from)
        next()  
    },
    methods: {
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
        fetch () {
            this.loading = true
            api.cases.casetype.get(this.$route.params.id)
                .then((data) => {
                    this.documentTitle(data.name)
                    this.casetype = data
                    this.loading = false
                    this.componentCreated = true
                })
        },
        oepnArticle(id) {
            this.focusArticle = id
            this.changed = false
        },
        truncatedBody (html) {
            const plainText = html.replace(/<\/?[^>]+(>|$)/g, "");
            if (plainText.length <= 50) {
                return plainText;
            }
            let truncatedText = plainText.substring(0, 50);
            truncatedText = truncatedText.substring(0, truncatedText.lastIndexOf(" "));
            return truncatedText + "..."
        },
        goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getNewsarticles(this.newsSearch)
            }
        },
        getNewsarticles (named = null) {
            this.newsLoading = true
            api.news.casenews.list({
                casetype: this.$route.params.id, pageNum: this.page, count: 10, ordering: '-created_at', search: this.newsSearch
            })
                .then((data) => {
                    this.total = data['count']
                    this.canNext = data['next_page'] !== null
                    this.canPrev = data['previous_page'] !== null
                    this.news = data['results']
                    this.newsLoading = false
                })
        },
    }
  }
  </script>
  
  <style scoped>
  
  .caseTypeCard {
      background:white;
      border-radius:10px;
      border:1px solid #26262623;
      padding:10px 15px 10px 25px;
  }
  
  </style>